import styled from 'styled-components'
import { colors } from '../../styles/constants'

export const Title = styled.h1`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28.8px;
  text-align: center;
  align-self: center;
  letter-spacing: 0.96px;
  margin: 6px 16px;
  color: ${colors.gray.darker};

  @media (min-width: 1024px) {
    text-align: left;
    margin: 8px 0 24px;
  }
`

export const Subtitle = styled.h5`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 19px;
  text-align: center;
  align-self: center;
  margin: 0px 16px;
  color: ${colors.gray.dark};

  @media (min-width: 1024px) {
    text-align: left;
    margin: 0 0 24px;
  }
`

export const Text = styled.p`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  align-self: left;
  margin: 16px;
  color: ${colors.gray.dark};

  span{
    font-size: 16px;
    font-weight: 600;
  }

  @media (min-width: 1024px) {
    margin: 0 0 24px;
  }
`
